import { render, staticRenderFns } from "./UrlText.vue?vue&type=template&id=6a785c5a&"
import script from "./UrlText.vue?vue&type=script&lang=js&"
export * from "./UrlText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports